// extracted by mini-css-extract-plugin
module.exports = {"invoiceListItemSelectedColor":"InvoiceListItem_invoiceListItemSelectedColor_2LDTw"};